import {
  defaultNumberFilter,
  defaultRelationFilter,
  defaultSelectFilter,
  type Filter,
} from '@/components/table-filters/constants';
import {
  IndustrialPremisesConfig,
  IndustrialPremisesContractConfig,
} from '@pigello/pigello-matrix';
import baseFilters, {
  baseGlobalRealEstatesFilter,
  baseTagFilter,
} from '../../filters';
import baseContractFilters from '../components/base-contract-filters';
import { Icons } from '@/components/icons';

const industrialPremisesContractFilters: Filter[] = [
  {
    ...defaultRelationFilter,
    title: IndustrialPremisesContractConfig.fields.space.verboseName,
    relationModelName: IndustrialPremisesConfig.modelName,
    externalFieldName:
      IndustrialPremisesContractConfig.fields.space.externalFieldName,
    icon: Icons.industrialpremisescontract,
  },
  {
    ...defaultSelectFilter,
    title: IndustrialPremisesConfig.fields.category.verboseName,
    externalFieldName: 'space_category',
    choices: IndustrialPremisesConfig.fields.category.choices,
  },
  {
    ...defaultNumberFilter,
    title: 'LOA (m²)',
    externalFieldName: 'space_usable_area',
  },
  ...baseGlobalRealEstatesFilter,
  ...baseContractFilters,
  ...baseTagFilter,
  ...baseFilters,
];

export default industrialPremisesContractFilters;
